export const initBlockData = {
  title: "Buy a Lux Express gift card - a gift that creates emotions and bring your loved ones together.",
  description: "<p>An e-gift card is a convenient way to purchase a gift card without visiting the store! Choose an e-gift card with a suitable value and personalize the text fields. You will receive it quickly via email.</p>",
  termsAndConditions: "<p><strong>Terms and conditions</strong></p><ul><li>Gift card (also known as voucher) can be used to purchase tickets from the Lux Express website luxexpress.eu or the mobile application only.</li><li>Gift card can be used as a purchase credit that is valid as a means of payment until the credit or gift card expires.</li><li>Gift card is valid for 1 year after the issuance.</li><li>Gift card validity cannot be extended.</li><li>The gift card value cannot be exchanged to money.</li></ul>",
};

export const initEmptyBlockData = {
  title: "",
  description: "",
  termsAndConditions: "",
};
